// extracted by mini-css-extract-plugin
export default {"indicator":"ChangedCostsIndicator_indicator__IXx46"};